import styled, { css } from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

const mixin = css`
  display: flex;
  align-items: center;
`;

export const FieldLoaderStyled = styled.div`
  position: absolute;
  height: 100%;
  top: 0;
  right: ${spacing(2.5)};
  ${mixin}
`;

export const SelectFieldLoaderStyled = styled.div`
  ${mixin}
`;
